import { dataService } from 'App';
import { FORM_URL_ENCODED_HEADERS_CONF } from 'utils/requestHelpers';

const infoServiceUrl='/users/infobar';

export function getEtkMessage() {
  return dataService.get(
    `${infoServiceUrl}/etkMessage`,
  );
}

export function getWorkingHours() {
  return dataService.get(
    `${infoServiceUrl}/workinghours`,
  );
}


export function getRecipientsByType(type) {
  return dataService.get(
    `${infoServiceUrl}/recipientsByType?type=${type}`,
  );
}

export function getRecipientsRehber() {
  return dataService.get(
    `${infoServiceUrl}/contactRecipients`,
  );
}

export function getTotalCreditByType(data) {
  const formParams = new URLSearchParams();
  for (const prop in data) {
    formParams.set(prop, data[prop]);
  }
  return dataService.post(
    `${infoServiceUrl}/totalcreditByType`,formParams, FORM_URL_ENCODED_HEADERS_CONF
  );
}


export function getSmsPart(data) {
  const searchParams = new URLSearchParams();
  for (const prop in data) {
    searchParams.set(prop, data[prop]);
  }
  return dataService.post(
    `${infoServiceUrl}/smspart`, searchParams, FORM_URL_ENCODED_HEADERS_CONF
  );
}
